/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IWatersportdiscountsSlideContainerConfig, IWatersportdiscountsSlideContainerProps } from './watersportdiscounts-slide-container.props.autogenerated';


export interface IWatersportdiscountsSlideContainerViewProps extends IWatersportdiscountsSlideContainerProps<IWatersportdiscountsSlideContainerConfig> {
    

    ctcategories: React.ReactNode[];
    ContentList: IModuleProps;
    ContentListItem: INodeProps;

    classNames: string;
}


/**
 *
 * ObrienSlideContainer component.
 * @extends {React.PureComponent<IWatersportdiscountsSlideContainerProps<IWatersportdiscountsSlideContainerConfig>>}
 */
 class WatersportdiscountsSlideContainer extends React.PureComponent<IWatersportdiscountsSlideContainerProps<IWatersportdiscountsSlideContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        
        const ClassNames = config.classNames ? config.classNames : '';

        
        const viewprops = {
            ...this.props,
            
            classNames: ClassNames,
            
            ctcategories: this.props.slots.contentSlot,
            ContentList: {
                moduleProps: this.props,
                className: classnames('content__list', this.props.config.className),
                tag: 'div'
            },
            ContentListItem: {
                className: classnames('content__list-item text-left', this.props.config.className),
                tag: 'div'
            },

            
        };

       

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default WatersportdiscountsSlideContainer;
